import { Steps } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { getArrayDocDataByRef } from "../models/DataFunctions";
import Icon1 from "../icons/Icon";

const TimelineNewInvoice = ({
  start_step = 0,
  step,
  steps_titles = [
    "Questionnaire",
    "Informations complétées",
    "Fichiers ajoutés",
    "Génération du devis",
  ],
}) => {
  const handleFetchData = async () => {
    // Fetch data from API
    // set steps
    let steps = steps_titles.map((title, index) => {
      return {
        title: title,
      };
    });
    setSteps(steps);
  };

  useEffect(() => {
    handleFetchData();
  }, []); // Dependency array ensures this runs only once
  const [current, setCurrent] = useState(0);

  const [steps, setSteps] = useState([]);

  return (
    <div className="flex flex-col  w-full  ">
      <BetterSteps items={steps} current={step - start_step} />
    </div>
  );
};

export default TimelineNewInvoice;

export const BetterSteps = ({ items, current }) => {
  return (
    <div className="flex items-center justify-center flex-col gap-4  w-full">
      <div className="flex flex-row justify-between w-full  min-h-fit">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex w-full h-4 flex-row items-center justify-start min-h-fit "
          >
            <div
              className={` min-w-8 h-8 ml-4 rounded-full items-center justify-center flex  ${index < current ? "bg-green-50" : index === current ? "bg-blue-50" : "bg-gray-50"}`}
            >
              <Icon1
                icon_name={
                  index < current
                    ? "done2"
                    : index === current
                      ? "warning"
                      : "horloge"
                }
                size={20}
                fill={
                  index < current
                    ? "#0cf480"
                    : index === current
                      ? "#0071ff"
                      : "lightgrey"
                }
              />
            </div>
            {index !== items.length - 1 && (
              <div
                className={` w-full  h-0.5 rounded-full  px-1 ${index < current - 1 ? "bg-green-100" : index === current - 1 ? "bg-blue-200" : "bg-gray-100"}`}
              ></div>
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-between  w-full   min-h-fit items-start">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex w-full  flex-row items-center justify-start min-h-fit "
          >
            {/* Step Circle */}

            {/* Step Label */}
            <div
              className={` text-h4 min-h-fit font-medium px-3   ${index < current ? "text-shadow_50" : index === current ? "text-black" : "text-shadow_25"}`}
            >
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
